export default "__VITE_PUBLIC_ASSET__696b25d7__"